import { Link } from 'react-router-dom'
import { IoIosContact } from 'react-icons/io'
import { FaFacebook } from 'react-icons/fa'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getHomeImages } from '../features/home/homeSlice'
import Spinner from '../components/Spinner'
import { sendPageView } from '../gtmUtils'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

function Home() {
	const dispatch = useDispatch()

	const { homeImages, isLoading, isSuccess } = useSelector((state) => state.homeImages)

	useEffect(() => {
		sendPageView()
		dispatch(getHomeImages())
	}, [dispatch])

	return (
		<>
			{isLoading || !isSuccess ? (
				<Spinner />
			) : (
				<div>
					<div className='home-inner'>
						<h1 className='x-large'>Sproxton General Contracting</h1>
						<div>
							<p className='lead'>
								Locally owned and operated in Brooklin, Ontario serving Durham Region and beyond.
							</p>
							<p className='p-1'>
								We offer a wide range of services from simple handyman jobs to larger renovation
								projects.
							</p>
							<p className='p-1'>
								Evening and weekend work is available if normal working hours are not convenient for
								you.
							</p>

							<Swiper
								modules={[Navigation, Pagination, Scrollbar, A11y]}
								slidesPerView={1}
								spaceBetween={50}
								pagination={{ clickable: true }}
								navigation
								scrollbar={{ draggable: true }}>
								{homeImages.map((image, index) => (
									<div className='swiper-parent'>
										<SwiperSlide key={index}>
											<div className='swiperSlideDiv'>
												<a href={image.full} target='_blank' rel='noreferrer'>
													<img src={image.thumbnail} alt={image.name} className='swiperSlideImg' />
												</a>
											</div>
										</SwiperSlide>
									</div>
								))}
							</Swiper>

							<p className='text-highlight p-2'>Free Estimates, Fully Insured</p>

							<p className='text-highlight p-1'>
								{' '}
								Payment Types Accepted: Cash, Cheque, e-Transfer
							</p>
						</div>
						<br />

						<a
							href='https://www.facebook.com/SproxtonGeneralContracting'
							target='_blank'
							rel='noreferrer'
							className='text-contact'>
							<FaFacebook /> Check out our Facebook page
						</a>

						<br />
						<Link to='/contact' className='text-contact'>
							<IoIosContact /> Contact Us
						</Link>
					</div>
				</div>
			)}
		</>
	)
}

export default Home
